module.exports = __webpack_public_path__ + "static/media/csv-groups.d9c70210.svg";